// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__dAZPj","colMin":"styles_colMin__1XHmr","colCheckbox":"styles_colCheckbox__2wX4n"};